import React, {Dispatch, SetStateAction, useCallback} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';

import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';

type Props = {
    selectedRecords: string[],
    onChange: Dispatch<SetStateAction<PresetRelationItem[]>>,
    onClose: () => void,
};

export const REMOVE_ENTITLEMENT_TOOL_MODAL_WIDTH = 400;

export const RemoveEntitlementToolModal = (props: Props) => {
    const {selectedRecords, onClose, onChange} = props;

    const onRemove = useCallback(() => {
        const data = selectedRecords.map(record => JSON.parse(record));

        const roles = data.filter(record => record.roleId);
        const grants = data.filter(record => record.grantId);

        onChange(prev => prev.filter(relation => {
            if (roles.length && relation.roleId) {
                return !roles.some(role => role.roleId === relation.roleId);
            }

            if (grants.length && !relation.roleId) {
                return !grants.some(grant => grant.grantId === relation.grantId);
            }

            return true;
        }));
        onClose();
    }, [selectedRecords, onChange, onClose]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Remove
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {pluralize('Are you sure you want to remove selected entitlement[s]?', selectedRecords.length)}
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button variant="Type.PRIMARY" onClick={onRemove}>
                        Remove
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
